export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { sm: 440, xs: "90%" },
  maxWidth: "95%",
  minWidth: "300px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  overflowY: "auto",
  maxHeight: "90vh",
};
